<template>
  <div class="calendar-input clearfix">
    <div class="form-group row">
      <label class="col-form-label col-sm-4" v-if="!pickerOptions.noLabel">
        {{ pickerOptions.label }}
        <span v-if="pickerOptions.required" class="required">*</span>
      </label>
      <div :class="{ 'col-sm-8' : !pickerOptions.noLabel, 'col': pickerOptions.noLabel }">
        <input class="form-control" ref="input"
        :type="type"
        :name="pickerOptions.name"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'CalendarInput',
  props: {
    value: {
      type: [String, Date]
    },
    options: {
      type: Object
    }
  },
  data () {
    return {
      picker: {},
      isDirty: false,
      isValid: true
    }
  },
  computed: {
    type () {
      return this.pickerOptions.inline ? 'hidden' : 'text'
    },
    pickerOptions () {
      return {
        label: '',
        name: '',
        inline: false,
        minDate: null,
        maxDate: null,
        format: 'DD/MM/YYYY',
        field: false,
        noLabel: false,
        ...this.options
      }
    }
  },
  mounted () {
    this.startCalendar()
  },
  methods: {
    setDate (date) {
      this.picker.setDate(date)
    },
    startCalendar () {
      let parent = this
      let inModal = false
      while (parent) {
        parent = parent.$parent
        if (parent && parent.$options._componentTag) {
          inModal = parent.$options._componentTag.includes('modal')
          if (inModal) parent = false
        }
      }
      let theme = inModal ? 'in-modal-theme' : false
      this.picker = new Pikaday({
        field: this.pickerOptions.inline ? false : this.$refs.input,
        defaultDate: moment(this.value).toDate(),
        setDefaultDate: true,
        onSelect: (date) => {
          this.$emit('input', date)
        },
        format: this.pickerOptions.format,
        minDate: moment(this.pickerOptions.minDate).toDate(),
        maxDate: moment(this.pickerOptions.maxDate).toDate(),
        theme
      })
      if (this.pickerOptions.inline) {
        this.$refs.input.parentNode.insertBefore(
          this.picker.el,
          this.$refs.input.nextSibling
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CalendarInput.vue